import React, { useEffect } from 'react';
import styled from 'styled-components';

import ReactPlayer from 'react-player';
import VidyardEmbed from '@vidyard/embed-code';

const PlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;
`;

const ResponsiveReactPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
`;

const VideoPlayer = ({ type, vidyard_uuid, files = [], url, ...other }) => {
  useEffect(() => {
    if (type === 'vidyard') {
      window.addEventListener(
        'onVidyardAPI',
        VidyardEmbed.api.renderDOMPlayers()
      );
      return () => {
        window.removeEventListener(
          'onVidyardAPI',
          VidyardEmbed.api.renderDOMPlayers()
        );
      };
    }
  });

  const videoSources = files.map(file => ({
    src: file.url,
    type: file.content_type
  }));

  return (
    <div {...other}>
      {type === 'vidyard' ? (
        <img
          className="vidyard-player-embed"
          src={`https://play.vidyard.com/${vidyard_uuid}.jpg`}
          data-uuid={vidyard_uuid}
          data-color="FFFFFF"
          data-playlist_color="FFFFFF"
          data-play_button_color="2A2A2A"
          data-type="inline"
          data-v="4"
          alt="Video Placeholder"
        />
      ) : (
        <PlayerWrapper>
          <ResponsiveReactPlayer
            url={
              type === 'file' && videoSources.length > 0 ? videoSources : url
            }
            controls
            width="100%"
            height="100%"
          />
        </PlayerWrapper>
      )}
    </div>
  );
};

export default VideoPlayer;
